import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import CommonSnackbar from "../common/commonSnackBar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { LoadingButton } from "@mui/lab";
import { BackupTable } from "@mui/icons-material";
import Constants from "../../utility/constants";
import NoPermission from "../common/noPermission";
import Select from "react-select";
import PageTitle from "../common/pageTitle";

const NewStone = () => {
  const [uploadResponse, setUploadResponse] = useState([]);
  const [uploadSuccessSnackbar, setUploadSuccessSnackbar] = useState(false);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [showError, setShowError] = useState(false);
  const [access, setAccess] = useState(false);
  const [stoneUploadType, setStoneUploadType] = useState([]);
  const [stoneUploadTypeOption, setStoneUploadTypeOption] = useState([]);

  useEffect(() => {
    PageTitle("OPERATION_NEWSTONE");
    checkPermission();
    getAllStoneUploadType();
  }, [])

  const checkPermission = () => {
    let allowed = Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.OPERATION_NEWSTONE &&
        iPermission.type === "ADD"
    ) !== undefined
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
  }

  const getAllStoneUploadType = () => {
    const type = Constants.STONE_UPLOAD_TYPE;
    setAllStoneUploadType(type);
  }

  const setAllStoneUploadType = (response) => {
    setStoneUploadTypeOption(response);
    setStoneUploadType(response.length > 0 ? response[0] : stoneUploadType);
  }

  const handleUpload = (e) => {
    let data = new FormData();
    data.append("file", e.target.files[0]);
    setUploadLoader(true);
    StoneProxy.UploadStones(data, stoneUploadType.value, (response) => {
      if (response) {
        setUploadResponse(response);
        setUploadSuccessSnackbar(true);
        setUploadLoader(false);
      } else {
        setShowError(true);
        setUploadLoader(false);
      }
    });
  };

  const handleClose = () => {
    setUploadSuccessSnackbar(false);
  };

  const handleClear = () => {
    const fileInput = document.getElementById('file-input');
    fileInput.value = null;
  }

  return (
    <div>
      {uploadResponse !== "" ? (
        <CommonSnackbar
          show={uploadSuccessSnackbar}
          message={
            uploadResponse.status === "SUCCESS"
              ? `File Upload Successfully \n Changes Will Reflect Within 5 Minutes`
              : uploadResponse.errorMessage
          }
          variant={uploadResponse.status === "SUCCESS" ? "success" : "error"}
          autoHide={false}
          title={uploadResponse.status === "SUCCESS" ? "Success" : "Error"}
          handleClose={handleClose}
        />
      ) : null}
      <CommonSnackbar
        show={showError}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setShowError(false)}
      />
      {
        access ? <NoPermission /> : (
          <div>
            <Container maxWidth="xxl">

              <Box
                sx={{ backgroundColor: '#ffrf' }}
                display={"flex"}
                justifyContent="center"
                alignItems={"center"}
                height={"80vh"}
                gap="20px"
                flexDirection={"column"}
              >
                <Box
                  display={"flex"}
                  justifyContent="center"
                  alignItems={"center"}
                  gap="20px"
                >
                  <Typography variant="h4">Upload Stones</Typography>
                  <Box
                    sx={{
                      width: "200px",
                    }}
                  >
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={stoneUploadTypeOption}
                      value={stoneUploadType}
                      isSearchable={false}
                      onChange={(e) => setStoneUploadType(e)}
                    /></Box>
                  <LoadingButton
                    variant="contained"
                    component="label"
                    szie="large"
                    loading={uploadLoader}
                    loadingPosition="start"
                    startIcon={<UploadFileIcon size="large" />}
                    color="success"
                  >
                    Upload
                    <input
                      id="file-input"
                      hidden
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      multiple
                      type="file"
                      onChange={(e) => handleUpload(e)}
                      onClick={(e) => handleClear()}
                    />
                  </LoadingButton>
                </Box>

                {stoneUploadType.value === "MANUFACTURING" && (
                  <Box display={'flex'} alignItems={"center"}>
                    <Typography variant="h6">Download Sample Manufacturing Upload &#8594; </Typography>
                    <a
                      href="/demo_excel/SampleManufacturingUpload.xls"
                      download="SampleManufacturingUpload.xls"
                      style={{ color: "red" }}
                    >
                      <BackupTable size={25} />
                    </a>
                  </Box>)}
                {stoneUploadType.value === "STOCK" && (
                  <Box display={'flex'} alignItems={"center"}>
                    <Typography variant="h6">Download Sample Stock Upload &#8594; </Typography>
                    <a
                      href="/demo_excel/SampleStockUpload.xls"
                      download="SampleStockUpload.xls"
                      style={{ color: "red" }}
                    >
                      <BackupTable size={25} />
                    </a>
                  </Box>)}

                <Box>
                  <Typography variant="body1">
                    <b>Note:</b> To upload Lab Grown Stones (CVD or HPHT), name the Excel sheet with "CVD" or "HPHT". <br />
                    For example: <i>CVD, CVD_WHITE, CVD_FANCY, CVD_Single_Mix, CVD_Mix</i>, and similar formats for HPHT. <br />
                    If the sheet name does not follow this convention, stones will be uploaded to <b>NATURAL</b> by default.
                  </Typography>
                </Box>

              </Box>
            </Container>
          </div >
        )
      }
    </div >
  );
};

export default NewStone;
